module.exports = __webpack_public_path__ + "static/media/kantoushan_plant.ca6a26de.png";